import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import segC from '../../../../../config/SegCCodeDef.json';
import './Cell.scss';

export default class CustomCell extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  };

  render() {
    const { value, type } = this.props;
    console.log(segC[type][value]);
    return (
      <React.Fragment>
        {type &&
          value && (
            <div>
              <Tooltip placement="right" title={segC[type][value]}>
                {value}
              </Tooltip>
            </div>
          )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/subcomponents/CustomItemCell/Cell.jsx